import React, { useState, useEffect } from "react";
import NavigationHelper from "../helpers/navigation";

export default function LangSwitcher(props) {
  let active_langs = {
    fr: "",
    en: "",
    es: "",
  };

  let styled_langs_links = {
    fr: {},
    en: {},
    es: {},
  };

  // Style of the selected language in the switcher
  const [activeLanguage, setActiveLanguage] = useState(active_langs);
  const [styledLanguagesLinks, setStyledLanguagesLinks] =
    useState(styled_langs_links);

  useEffect(() => {
    // Update the active language state when current_lang prop changes
    setActiveLanguage({ ...active_langs, [props.current_lang]: "active" });
    setStyledLanguagesLinks({
      ...styled_langs_links,
      [props.current_lang]: { cursor: "default" },
    });
  }, [props.current_lang]); // Depend on `props.current_lang`

  const pageLinksMap = {
    fr: NavigationHelper.useGeneratePageURL(
      "fr",
      props.current_page,
      props.current_item
    ),
    en: NavigationHelper.useGeneratePageURL(
      "en",
      props.current_page,
      props.current_item
    ),
    es: NavigationHelper.useGeneratePageURL(
      "es",
      props.current_page,
      props.current_item
    ),
  };

  return (
    <>
      <div>
        <span>
          <a
            title={props.version_fr_title}
            href={pageLinksMap["fr"]}
            className={`lag-link ${activeLanguage["fr"]}`}
            style={styledLanguagesLinks["fr"]}
          >
            FR{" "}
          </a>{" "}
          |
          <a
            title={props.version_en_title}
            href={pageLinksMap["en"]}
            className={`lag-link ${activeLanguage["en"]}`}
            style={styledLanguagesLinks["en"]}
          >
            {" "}
            En{" "}
          </a>{" "}
          |
          <a
            title={props.version_es_title}
            href={pageLinksMap["es"]}
            className={`lag-link ${activeLanguage["es"]}`}
            style={styledLanguagesLinks["es"]}
          >
            {" "}
            Es
          </a>
        </span>
      </div>
    </>
  );
}
